// https://blog.alexdevero.com/custom-styled-google-map-react/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api';
import RecenterIcon from '../images/map-recenter.svg';
import mapMarkerChauffeur from '../images/map-pin-chauffeur.svg';

// Import custom styles to customize the style of Google Map
const styles = require('./GoogleMapStyles.json');

// Import custom icon for map marker

const mapContainerStyle = {
  width: '100%',
  height: '100%'
};

class GoogleMapComponentWithMarker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoRecenter: true,
      // initialZoom is the zoom level saved when Idle's called. Set to null means it's
      // not yet been set. When ZoomChanged is called, I check to see whether zoom has
      // "really" changed, if so then turn off autorecenter.
      initialZoom: null
    };
  }

  // State updates when there's a new location from the chauffeur. So recenter
  // if we're autocentering.

  resizeMap = () => {
    if (!window.google || !window.google.maps) {
      return;
    }

    // Here, we are checking if there is more than one waypoint or a chauffeur
    // location if there is the we will use fitBounds to include all waypoints
    // and potentially a chauffeur location as well. (defaultZoom if there is 1 pin)
    const { markers, chauffeurPosition } = this.props;
    if (markers[1] || chauffeurPosition.latitude) {
      const bounds = new window.google.maps.LatLngBounds();
      if (chauffeurPosition.latitude) {
        bounds.extend({ lat: Number(chauffeurPosition.latitude), lng: Number(chauffeurPosition.longitude) });
      }
      markers.map(marker => {
        bounds.extend(marker);
        return marker.id;
      });

      if (this._map && this._map.fitBounds) {
        this._map.fitBounds(bounds, { bottom: 60, top: 60, left: 60, right: 60 });
      }
    }
  };

  setAutoRecenter = newMode => {
    this.setState({ autoRecenter: newMode });
  };

  recenterButton = () => {
    const recenterIconStyle = {
      position: 'absolute',
      background: '#ffffff',
      top: 42,
      right: 40,
      height: 40,
      width: 40,
      radius: 10,
      padding: 8,
      borderRadius: 3
    };
    return (
      <img
        src={RecenterIcon}
        alt="Recenter Button"
        style={recenterIconStyle}
        onClick={() => this.setAutoRecenter(true)}
      />
    );
  };

  render() {
    const { markers, chauffeurPosition } = this.props;

    return (
      <div>
        <LoadScript
          googleMapsApiKey="AIzaSyAbn7ppWMwyvB9zeLEKuWLXaFEef16_Ehs"
          libraries={['places', 'geometry']}
          language="en"
          id="google-maps-script"
        >
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={14}
            center={{
              lat: markers[0].lat,
              lng: markers[0].lng
            }}
            options={{
              styles: styles, // change default map styles
              keyboardShortcuts: false,
              disableDefaultUI: true,
              draggable: true,
              scaleControl: true,
              scrollwheel: true,
              zoomControl: true,
              zoomControlOptions: { position: 9 }
            }}
            onDragStart={() => {
              this.setAutoRecenter(false);
            }}
            onLoad={map => {
              this._map = map;
              setTimeout(() => {
                this.resizeMap();
              }, 100);
            }}
            onZoomChanged={() => {
              if (
                this._map &&
                this._map.getZoom &&
                this._map.getZoom() !== this.state.initialZoom &&
                this.state.initialZoom !== null
              ) {
                this.setAutoRecenter(false);
              }
            }}
            onIdle={() => {
              // saving initial zoom, now that the dust has settled
              if (this._map && this._map.getZoom && this.state.initialZoom === null) {
                this.setState({ initialZoom: this._map.getZoom() });
              }
            }}
          >
            <span>
              {chauffeurPosition.latitude ? (
                <Marker
                  icon={{
                    url: mapMarkerChauffeur.default || mapMarkerChauffeur
                  }}
                  position={{
                    lat: Number(chauffeurPosition.latitude),
                    lng: Number(chauffeurPosition.longitude)
                  }}
                  zIndex={markers.length}
                />
              ) : (
                ''
              )}
              {markers.map(marker => {
                marker.uniqId = (marker.stopNumber || markers.indexOf(marker)) + 1;

                const numberedWaypointIcon = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
                  <svg width="32" height="40" viewBox="0 0 32 40" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 0C7.163 0 0 7.163 0 16c0 16 16 24 16 24s16-8 16-24C32 7.163 24.837 0 16 0z" fill="#FFB000"/>
                    <circle cx="16" cy="16" r="12" fill="#FFB000"/>
                    <circle cx="16" cy="16" r="8" fill="#FFB000"/>
                    <text x="16" y="20" text-anchor="middle" fill="#000000" font-family="Roboto, Arial, sans-serif" font-size="12" font-weight="bold">${marker.uniqId}</text>
                  </svg>
                `)}`;

                return (
                  <Marker
                    key={marker.uniqId}
                    icon={{
                      url: numberedWaypointIcon,
                      scaledSize: { width: 32, height: 40 },
                      anchor: { x: 16, y: 40 }
                    }}
                    position={{
                      lat: marker.lat,
                      lng: marker.lng
                    }}
                    zIndex={markers.length - marker.uniqId}
                  />
                );
              })}
            </span>
          </GoogleMap>
        </LoadScript>
        {this.recenterButton()}
      </div>
    );
  }
}

// Export Google Map component
export default GoogleMapComponentWithMarker;

GoogleMapComponentWithMarker.propTypes = {
  chauffeurPosition: PropTypes.object.isRequired,
  markers: PropTypes.array.isRequired
};
